import React from 'react';
import { BsBuildings } from "react-icons/bs";
import { Tabs } from '../../../app/components/Tabs';
import RegisterClient from './tabsClient/RegisterClient';
import ContactClient from './tabsClient/ContactsClient';
import AccessClient from './tabsClient/AccessClient';
import OffCanvas from '../../../app/components/OffCanvas';

const ClienteOffCanvas = ({
  isOpen,
  onClose,
  empresaSelecionada,
  selectedCompany,
  activeTab,
  setActiveTab,
  handleStatusChange,
  contactsByCompany,
  accessByCompany,
  setShowAcessAdd,
  setShowContactsAdd,
  openDeletModal,
  handleUpdateEmpresaField
}) => (
  <OffCanvas
    title="Detalhes do Cliente"
    isOpen={isOpen}
    onClose={onClose}
  >
    <div className='border-b pb-4'>
      <div className='flex mb-2 gap-2'>
        <BsBuildings size={18}/>
        <h1 className='uppercase font-bold'>
          {empresaSelecionada ? empresaSelecionada.nomeFantasia : 'Nome da empresa'}
        </h1>
      </div>
      <div className='col-span-3'>
        <div>
          <p className='text-xs text-gray-700'>Criada: 13/05/2025 23:06:16</p>
          <p className='text-xs text-gray-700'>Modificada: 23/06/2025 18:08:59</p>
          <div className="flex gap-2 mt-4">
            {[
              { id: 'active', label: 'Ativo', value: 'ativo' },
              { id: 'inactive', label: 'Inativo', value: 'inativo' },
            ].map((option) => (
              <div key={option.id} className="flex items-center gap-1">
                <input
                  type="radio"
                  id={option.id}
                  name="actves"
                  value={option.value}
                  checked={empresaSelecionada?.status === option.value.toLowerCase()}
                  onChange={() => handleStatusChange(option.value)}
                  className="appearance-none w-4 h-4 border-2 border-[#672c71] cursor-pointer rounded-full relative flex items-center justify-center bg-white checked:bg-white before:content-[''] before:w-2 before:h-2 before:rounded-full before:bg-[#672c71] before:scale-0 before:transition-transform checked:before:scale-100"
                />
                <label htmlFor={option.id} className="flex items-center cursor-pointer text-gray-700 gap-1">
                  <p>{option.label}</p>
                </label>
              </div>
            ))}

            {empresaSelecionada?.churn === 'churn' && (
              <div className="flex items-center ml-auto text-[#a40ccb] text-sm font-medium gap-1">
                <span>CHURN</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>

    <div className="mt-4">
      <Tabs
        tabsName={['Cadastro', 'Contatos', 'Acessos']}
        activeTabName={
          activeTab === 'register' ? 'Cadastro' :
          activeTab === 'contact' ? 'Contatos' :
          'Acessos'
        }
        onTabClick={(tabName) => {
          const key = tabName === 'Cadastro' ? 'register' : tabName === 'Contatos' ? 'contact' : 'access';
          setActiveTab(key);
          if (key !== 'access') setShowAcessAdd(false);
          if (key !== 'contact') setShowContactsAdd(false);
        }}
      />
    </div>

    <div className="mt-4">
      {activeTab === 'register' && (
        <RegisterClient
          empresa={selectedCompany}
          handleFieldChange={handleUpdateEmpresaField}
        />
      )}

      {activeTab === 'contact' && (
        <ContactClient
          onOpenAccess={() => setShowContactsAdd(true)}
          empresa={selectedCompany}
          contactsList={contactsByCompany[selectedCompany?.id] || []}
          onDelete={(item) => openDeletModal(item, 'contato')}
        />
      )}

      {activeTab === 'access' && (
        <AccessClient
          onOpenAccess={() => setShowAcessAdd(true)}
          empresa={selectedCompany}
          acessList={accessByCompany[selectedCompany?.id] || []}
          onDelete={(item) => openDeletModal(item, 'acesso')}
        />
      )}
    </div>
  </OffCanvas>
);

export default ClienteOffCanvas;
